import { Component, OnInit } from '@angular/core';
import { AuthService } from  '../shared/auth.service';
import { Router } from '@angular/router';
import { NotificationService } from '../shared/notification.service';
// import {ToastyService, ToastyConfig} from 'ng2-toasty';

@Component({
    template: require('./partials/admin-root.component.html'),
    styles: [require('../../../node_modules/admin-lte/dist/css/AdminLTE.min.css')],
    // providers: [ToastyService,ToastyConfig]
    providers: [NotificationService]
})
export class AdminRootComponent implements OnInit {

    public loggedInUser: string;
    public loggedIn: boolean;

    constructor(private router: Router, private authService: AuthService) {
    }

    logout(){
        this.authService.logout()
            .then(response => {
                this.router.navigate(['/login']);
            });
    }

    ngOnInit(){
        this.loggedInUser = this.authService.loggedInUser; 
        this.loggedIn = this.authService.loggedInUser != null; 
        console.log('[auth]', this.loggedInUser);
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-root.component.ts